import React, {Suspense, useEffect} from 'react';
import 'antd/dist/antd.css'
import {ConfigProvider, Layout} from 'antd'
import {Router} from 'react-router-dom'
import {Header} from './components/Header'
import {useDispatch, useSelector} from 'react-redux'
import history from './helpers/history'
import Routes from './routes'
import {Footer} from './components/Footer';
import {AppStateType} from './store'
import GlobalLoading from './components/Loading/Global'
import 'moment/locale/ru'
import {getAuthUserData} from "./store/actions/user";

const { Content } = Layout;

function App() {
    const {isGlobalLoadingVisible} = useSelector((state: AppStateType) => state.globalReducer)
    const {lang} = useSelector((state: AppStateType) => state.language)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAuthUserData())
    },[])
    return (
        <ConfigProvider locale={lang}>
            <Layout style={{maxHeight : "100%", background: 'inherit'}}>
                <Suspense fallback={<GlobalLoading/>}>
                    <Header />
                    <Content className="site-layout">
                        <div className="site-layout-background" style={{minHeight: 380}}>
                            <Routes />
                        </div>
                        {isGlobalLoadingVisible && <GlobalLoading/>}
                    </Content>
                    {/*<Footer/>*/}
                </Suspense>
            </Layout>
        </ConfigProvider>
    );
}

const VarietyApp: React.FC = () => {
    ConfigProvider.config({
        theme: {
            //textColor: 'rgba(0, 0, 0, 0.7)'
        }
    })
    return <Router history={history}>
        <App/>
    </Router>
}

export default VarietyApp